const model = {
	element : $('.js-popular'),
	main : $('.js-popular__main'),
	content : $('.js-popular__content'),
	footer : $('.js-popular__footer'),
	defaultMainHeight : $('.js-popular__main').height(),
	defaultContentHeight: 270,
	isEmpty() {
		(this.content.height() > this.main.height()) ? this.defaultContentHeight =  this.main.height() : '';
		return (this.content.height() > this.main.height());
	},
	showFoot() {
		if (this.isEmpty()) {
			this.footer.fadeIn();
		}
	},
	currentHeight() {
		if (this.isEmpty()) {
			this.main.animate({
				maxHeight : this.content.height() + 'px'
			}, 500);
			
		}
	},
	defaultHeight() {
		this.main.animate({
			maxHeight : this.defaultContentHeight + 'px'
		}, 500);
	}
}
$(document).ready(function() {
	model.showFoot();
});
$(document).on('click', '.js-popular__button', function(e) {
	e.preventDefault();
	$(this).toggleClass('current');
	if ($(this).hasClass('current')) {
		model.currentHeight();
	} else {
		model.defaultHeight();
	}
});

export {
	model
};
//(4).plus(4).minus(3)